import React from 'react';

const ERROR_MESSAGES = {
  domain: 'That account is not on an allowed domain. Sign in with your @60decibels.com account.',
  access_denied: 'Sign-in was cancelled.',
  state: 'Sign-in session expired. Please try again.',
  token: 'Could not complete sign-in. Please try again.',
  oauth: 'Something went wrong during sign-in. Please try again.',
};

function Login({ theme, onToggleTheme }) {
  const params = new URLSearchParams(window.location.search);
  const errorKey = params.get('error');
  const errorMsg = errorKey ? ERROR_MESSAGES[errorKey] || 'Sign-in failed.' : '';

  return (
    <div
      style={{
        minHeight: '100dvh',
        backgroundColor: theme.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: theme.font,
        padding: 24,
        color: theme.text,
      }}
    >
      <button
        type="button"
        onClick={onToggleTheme}
        aria-label="Toggle theme"
        style={{
          position: 'fixed',
          top: 16,
          right: 16,
          border: `1px solid ${theme.border}`,
          background: theme.surface,
          color: theme.textMuted,
          borderRadius: 999,
          padding: '8px 14px',
          fontSize: 13,
          cursor: 'pointer',
        }}
      >
        {theme.mode === 'dark' ? 'Light' : 'Dark'}
      </button>

      <div
        style={{
          width: '100%',
          maxWidth: 400,
          backgroundColor: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: theme.radius,
          padding: 36,
          boxShadow: theme.shadow,
          textAlign: 'center',
        }}
      >
        <img
          src="/60-DB.png"
          alt="60 Decibels"
          style={{ height: 72, marginBottom: 28, objectFit: 'contain', maxWidth: '80%' }}
        />
        <h1
          style={{
            fontSize: 22,
            fontWeight: 600,
            margin: '0 0 28px',
            letterSpacing: '-0.02em',
          }}
        >
          Survey Link Generator
        </h1>

        {errorMsg && (
          <div
            style={{
              backgroundColor: 'rgba(220,38,38,0.08)',
              border: '1px solid rgba(220,38,38,0.35)',
              color: theme.danger,
              fontSize: 13,
              borderRadius: 10,
              padding: '10px 12px',
              marginBottom: 20,
              textAlign: 'left',
            }}
          >
            {errorMsg}
          </div>
        )}

        <a
          href="/api/auth/google"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            width: '100%',
            padding: '13px 20px',
            backgroundColor: theme.mode === 'dark' ? '#fff' : theme.text,
            color: theme.mode === 'dark' ? '#1f1f1f' : '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 600,
            textDecoration: 'none',
            boxSizing: 'border-box',
          }}
        >
          Sign in with Google
        </a>
      </div>
    </div>
  );
}

export default Login;
